<script setup lang="ts">
import type { MorningTheme } from '~~/shared/types/morning'

withDefaults(defineProps<{ theme: MorningTheme; compact?: boolean }>(), { compact: false })
const emit = defineEmits<{ cycleTheme: [] }>()

type HeaderPopover = 'notifications' | 'applications' | 'user'
const activePopover = ref<HeaderPopover | null>(null)
const route = useRoute()

watch(
  () => route.fullPath,
  () => (activePopover.value = null),
)

function toggle(popover: HeaderPopover) {
  activePopover.value = activePopover.value === popover ? null : popover
}

function cycleTheme() {
  activePopover.value = null
  emit('cycleTheme')
}
</script>

<template>
  <div
    class="header-actions"
    :class="{ 'header-actions--compact': compact }"
  >
    <UiThemeControl
      :theme="theme"
      @cycle="cycleTheme"
    />
    <NotificationsNotificationBell
      :open="activePopover === 'notifications'"
      @toggle="toggle('notifications')"
      @close="activePopover = null"
    />
    <DashboardApplicationLauncher
      :open="activePopover === 'applications'"
      @toggle="toggle('applications')"
      @close="activePopover = null"
    />
    <DashboardUserMenu
      :open="activePopover === 'user'"
      @toggle="toggle('user')"
      @close="activePopover = null"
    />
  </div>
</template>
